<div class="content">
  <span class="mat-title"> Pagamento </span>
  <!-- <mat-progress-bar *ngIf="submiting" mode="indeterminate"></mat-progress-bar> -->
  
  <h3
    style="text-align: center"
    class="title-snackbar"
    *ngIf="user.signature_status === 'PENDING'"
  >
    Seu período de teste terminou. <br />Confirme o plano escolhido, a forma de
    pagamento ou insira um novo cupom.
  </h3>

  <h3
    style="text-align: center"
    class="title-snackbar"
    *ngIf="user.signature_status === 'TRIAL'"
  >
    Seu período de teste tem validade até {{trialDate}}. <br />Confirme o plano escolhido, a forma de
    pagamento ou insira um novo cupom.
  </h3>

  <app-plan-slide
    style="position: absolute; left: -9999px"
    (choosePlan)="choosePlan($event)"
    [selectedPlan]="user.signature_plan_id"
    [planType]="planType"
    [itemsPerSlide]="3"
  ></app-plan-slide>

  <mat-dialog-content>
    <ng-template #stepOne>
      <form [formGroup]="form">
        <fieldset><legend>Informações do Plano</legend></fieldset>
        <div class="row" formGroupName="step1">
          <mat-form-field appearance="fill" style="margin-bottom: 0; padding-bottom: 0;">
            <mat-label>Escolha um Plano</mat-label>
            <mat-select
              placeholder="Selecione uma opção"
              formControlName="planName"
              (selectionChange)="updatePlanSelect($event)"
            >
              <mat-option value="4">Plano Anual</mat-option>
              <mat-option value="3">Plano Semestral</mat-option>
              <mat-option value="2">Plano Trimestral</mat-option>
              <mat-option value="1">Plano Mensal</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('step1.planName').errors?.required"
              >Por favor escolher uma opção</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="fill" style="margin-bottom: 0; padding-bottom: 0;">
            <!-- <mat-label>Escolha entre pagamento à vista ou parcelado.</mat-label> -->
            <mat-label>Escolha um pagamento (consulte os valores).</mat-label>
            <mat-select
              placeholder="Selecione uma opção"
              formControlName="planSelect"
              (selectionChange)="updatePlanSelect($event)"
            >
              <ng-container
                *ngIf="signaturePlan?.index == 4"
              >
                <mat-option value="YEARLY_BUSINESS"
                  >Plano Anual (À Vista) - R$5.058,91</mat-option
                >
              </ng-container>
              <ng-container
                *ngIf="signaturePlan?.index == 3"
              >
                <mat-option value="SIXMONTHLY_BUSINESS"
                  >Plano Semestral (À Vista) - R$2.687,54</mat-option
                >
              </ng-container>
              <ng-container
                *ngIf="signaturePlan?.index == 2"
              >
                <mat-option value="TREEMONTHLY_BUSINESS"
                  >Plano Trimestral (À Vista) - R$1.422,81</mat-option
                >
              </ng-container>
              <ng-container
                *ngIf="signaturePlan?.index == 1"
              >
                <mat-option value="MONTHLY_BUSINESS"
                  >Plano Mensal (À Vista) - R$526,97</mat-option
                >
              </ng-container>
            </mat-select>
            <mat-error *ngIf="form.get('step1.planSelect').errors?.required"
              >Por favor escolher uma opção</mat-error
            >
          </mat-form-field>
        </div>
        <div style="flex: 1;">
          <mat-tab-group (selectedIndexChange)="changePaymentMethod($event)">
            <mat-tab label="Pagar no boleto">
              <div class="empty-content">
                <p class="mat-body-2">
                  Clique em "próximo" para prosseguir com o pagamento via
                  boleto.
                </p>
              </div>
            </mat-tab>

            <!-- <ng-container *ngIf="signaturePlan?.index > -1">
              <mat-tab label="Pagar com cartão">
                <p style="padding-top: 5px;">As informações a seguir devem ser referentes ao titular do cartão:</p>
                <div class="row" formGroupName="step1">
                  <mat-form-field appearance="fill" id="tourPaymentCardInfo">
                    <mat-label>Número do cartão de crédito</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Informe o numero do seu cartão de crédito"
                      formControlName="cardNumber"
                      autofocus
                      maxlength="19"
                      (keyup)="onCompleteInput($event, 'holderName')"
                      mask="0000 0000 0000 0000"
                      id="cardNumber"
                    />
                    <mat-error *ngIf="form.get('step1.cardNumber').errors?.required"
                      >Por favor informar o nº do cartão</mat-error
                    >
                  </mat-form-field>

                  <mat-form-field appearance="fill">
                    <mat-label>Bandeira do cartão</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Bandeira do cartão"
                      formControlName="brandCard"
                      [readonly]="true"
                    />
                    <mat-error *ngIf="form.get('step1.brandCard').errors?.required"
                      >Por favor informar a bandeira do cartão</mat-error
                    >
                    <mat-progress-bar
                      color="primary"
                      mode="indeterminate"
                      *ngIf="submitingCardBrand"
                    ></mat-progress-bar>
                  </mat-form-field>

                </div>

                <div class="row" formGroupName="step1">
                  <mat-form-field appearance="fill">
                    <mat-label>Nome do Titular</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Nome como esta no cartão"
                      formControlName="holderName"
                      id="holderName"
                    />
                    <mat-error *ngIf="form.get('step1.holderName').errors?.required"
                      >Por favor informar o nome do titular</mat-error
                    >
                  </mat-form-field>
                </div>

                <div class="row" formGroupName="step1">
                  <mat-form-field appearance="fill">
                    <mat-label>Data de validade</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Ex: 11/2030"
                      formControlName="expirationDate"
                      id="expirationDate"
                      mask="00/0000"
                      maxlength="7"
                      (keyup)="onCompleteInput($event, 'cvv')"
                      (blur)="onBlur()"
                    />
                    <mat-error
                      *ngIf="form.get('step1.expirationDate').hasError('required')"
                      >Por favor informar a data de validade</mat-error
                    >
                    <mat-error *ngIf="form.get('step1.expirationDate').hasError('expirationDate') && !form.get('step1.expirationDate').hasError('required')">
                      <ng-container *ngIf="form.get('step1.expirationDate').errors?.expirationDate?.invalid">
                        Formato inválido. Use (ex: 10/2026).
                      </ng-container>
                      <ng-container *ngIf="form.get('step1.expirationDate').errors?.expirationDate?.pastDate">
                        Validade Vencida.
                      </ng-container>
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="fill">
                    <mat-label>Código de segurança</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Código de segurança do cartão"
                      formControlName="cvv"
                      mask="009"
                      id="cvv"
                    />
                    <mat-error *ngIf="form.get('step1.cvv').errors?.required"
                      >Por favor informar o código cvv</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="row" formGroupName="step1">
                  <mat-form-field appearance="fill">
                    <mat-label>CPF do Titular</mat-label>
                    <input
                      matInput
                      type="text"
                      placeholder="Informe o cpf"
                      mask="000.000.000-00"
                      formControlName="cpf"
                      inputmode="numeric"
                      (blur)="onCpfBlur()"
                    />
                    <mat-error *ngIf="form.get('step1.cpf').errors?.required"
                      >Por favor informar o CPF</mat-error
                    >
                    <mat-error *ngIf="form.get('step1.cpf').hasError('cpf')">
                      CPF inválido
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="fill">
                    <mat-label>Data de Nascimento do Titular</mat-label>
                    <input
                      matInput
                      type="text"
                      mask="00/00/0000"
                      inputmode="numeric"
                      placeholder="Informe a data de nascimento"
                      formControlName="birthdate"
                      (blur)="validateBirthdate()"
                    />
                    <mat-error *ngIf="form.get('step1.birthdate').errors?.required"
                      >Por favor informar a data de nascimento</mat-error
                    >
                    <mat-error *ngIf="form.get('step1.birthdate').hasError('invalidDate')">
                      Formato inválido. Use (ex: 10/10/1995).
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="row" formGroupName="step1">
                  <mat-form-field appearance="fill">
                    <mat-label>Telefone do Titular</mat-label>
                    <input
                      type="text"
                      placeholder="Seu telefone"
                      matInput
                      formControlName="phone"
                      [mask]="phoneMask"
                      inputmode="numeric"
                      (input)="onPhoneInput($event)"
                    />
                    <mat-error *ngIf="form.get('step1.phone').errors?.required"
                      >Por favor informar o telefone</mat-error
                    >
                    <mat-error *ngIf="form.get('step1.phone').hasError('invalidLength')">Número de telefone incompleto</mat-error>
                  </mat-form-field>
                </div>
              </mat-tab>
            </ng-container> -->
          </mat-tab-group>
        </div>
      </form>
    </ng-template>

    <ng-template #stepTwo>
      <form [formGroup]="form">
        <fieldset><legend>Informações do Plano</legend></fieldset>
        <span>
          Por favor, verifique se os dados abaixo estão corretos e corrija-os,
          se necessário, antes de continuar com o pagamento.
        </span>
        
        <div class="row" formGroupName="step2" style="margin-top: 10px;">
          <mat-form-field appearance="fill">
            <mat-label>Razão social</mat-label>
            <input
              type="text"
              placeholder="Razao social"
              matInput
              formControlName="companyName"
            />
            <mat-error *ngIf="form.get('step2.companyName').errors?.required"
              >Por favor informar a razão social</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>CNPJ</mat-label>
            <input
              type="text"
              placeholder="CNPJ da empresa"
              matInput
              formControlName="cnpj"
              mask="00.000.000/0000-00"
              inputmode="numeric"
            />
            <mat-error *ngIf="form.get('step2.cnpj').errors?.required"
              >Por favor informar o CNPJ</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input
              type="email"
              placeholder="Email"
              matInput
              formControlName="email"
            />
            <mat-error *ngIf="form.get('step2.email').errors?.required"
              >Por favor informar o e-mail</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>Telefone</mat-label>
            <input
              type="text"
              placeholder="Seu telefone"
              matInput
              formControlName="phone"
              [mask]="phoneMask"
              inputmode="numeric"
              (input)="onPhoneInput($event)"
            />
            <mat-error *ngIf="form.get('step2.phone').errors?.required"
              >Por favor informar o telefone</mat-error
            >
            <mat-error *ngIf="form.get('step2.phone').hasError('invalidLength')">Número de telefone incompleto</mat-error>
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>Nome Completo</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe seu nome completo"
              formControlName="fullname"
            />
            <mat-error *ngIf="form.get('step2.fullname').errors?.required"
              >Por favor informar o nome completo</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>CEP</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe seu cep"
              formControlName="zipCode"
              mask="00000-000"
              inputmode="numeric"
            />
            <mat-error *ngIf="form.get('step2.zipCode').errors?.required"
              >Por favor informar o CEP</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Estado</mat-label>
            <mat-autocomplete
              #autoState="matAutocomplete"
              [displayWith]="displayState"
              (optionSelected)="onStateSelected($event)"
            >
              <ng-container *ngFor="let state of filteredStates$ | async">
                <mat-option [value]="state">{{ state.nome }}</mat-option>
              </ng-container>
            </mat-autocomplete>
            <input
              matInput
              type="text"
              placeholder="Informe o estado"
              formControlName="state"
              [matAutocomplete]="autoState"
            />
            <mat-error *ngIf="form.get('step2.state').errors?.required"
              >Por favor informar o estado</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>Cidade</mat-label>
            <mat-autocomplete #autoCity="matAutocomplete">
              <ng-container *ngFor="let city of filteredCities$ | async">
                <mat-option [value]="city.name">{{ city.name }}</mat-option>
              </ng-container>
            </mat-autocomplete>
            <input
              matInput
              type="text"
              placeholder="Informe a cidade"
              formControlName="city"
              [matAutocomplete]="autoCity"
            />
            <mat-error *ngIf="form.get('step2.city').errors?.required"
              >Por favor informar a cidade</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Bairro</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe seu bairro"
              formControlName="district"
            />
            <mat-error *ngIf="form.get('step2.district').errors?.required"
              >Por favor informar o bairro</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>Rua/avenida</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe a rua/avenida"
              formControlName="street"
            />
            <mat-error *ngIf="form.get('step2.street').errors?.required"
              >Por favor informar a rua</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" formGroupName="step2">
          <mat-form-field appearance="fill">
            <mat-label>Número de residência</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe número da sua residência"
              formControlName="number"
              inputmode="numeric"
            />
            <mat-error *ngIf="form.get('step2.number').errors?.required"
              >Por favor informar o número</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Complemento</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe o complemento"
              formControlName="complement"
            />
          </mat-form-field>
        </div>
      </form>
    </ng-template>

    <ng-template #sidebar>
      <div class="lateral">
        <h2 style="font-weight: 800">Resumo do Pedido</h2>

        <div class="pedido">
          <span>{{ signaturePlan?.title }}</span>
          <span
            ><strong>R$ {{ signaturePlan?.price }}</strong></span
          >
        </div>

        <div class="voucher-form-container">
          <div style="text-align: center">
            <!-- <span class="mat-title"> Cupom </span> -->

            <span class="helper" [class.success-background]="success">
              <mat-icon *ngIf="!success">loyalty</mat-icon>
              <mat-icon *ngIf="success" style="color: #f3fff3"
                >check_circle</mat-icon
              >
              {{ message }}
            </span>
          </div>

          <form
            [formGroup]="formVoucher"
            (submit)="submitCode()"
            style="margin-top: 10px"
          >
            <div class="row">
              <div class="col w-100">
                <mat-form-field
                  appearance="outline"
                  id="tourPaymentCupom"
                  *ngIf="!success"
                >
                  <mat-label>Código de cupom</mat-label>
                  <input
                    type="text"
                    matInput
                    placeholder="Informe o código aqui"
                    class="voucher-code"
                    formControlName="code"
                    maxlength="8"
                    [readonly]="formVoucher.get('code').disabled"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <div class="actions" *ngIf="!success">
                  <button
                    type="submit"
                    mat-raised-button
                    color="primary"
                    class="button-large custom-primary"
                  >
                    Aplicar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="pedido">
          <span><strong>Total</strong></span>
          <span>R$ {{ signaturePlan?.price }}</span>
        </div>
        <form [formGroup]="form">
          <div class="row">
            <button
              mat-raised-button
              color="primary"
              style="width: 100%; margin-top: 20px"
              class="custom-primary"
              (click)="submit()"
            >
              Efetuar Pagamento
            </button>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-container *ngIf="isSmallScreen$ | async; else largeStepper">
      <mat-vertical-stepper #financeStepper>
        <mat-step label="Passo 1" #step1>
          <ng-container *ngTemplateOutlet="stepOne"></ng-container>
          <div class="step-buttons">
            <button
              mat-raised-button
              color="primary"
              class="custom-primary"
              matStepperNext
            >
              Próximo
            </button>
          </div>
        </mat-step>
        <mat-step label="Passo 2" #step2>
          <ng-container *ngTemplateOutlet="stepTwo"></ng-container>
          <div class="actions right">
            <button
              mat-raised-button
              color="primary"
              class="custom-primary"
              matStepperPrevious
            >
              Voltar
            </button>
          </div>
        </mat-step>
      </mat-vertical-stepper>
      <div style="width: 100%">
        <ng-container *ngTemplateOutlet="sidebar"></ng-container>
      </div>
    </ng-container>

    <ng-template #largeStepper>
      <div class="contain-flex">
        <div class="main-content">
          <mat-horizontal-stepper #financeStepper>
            <mat-step label="Passo 1" #step1>
              <ng-container *ngTemplateOutlet="stepOne"></ng-container>
              <div class="step-buttons">
                <button
                  mat-raised-button
                  color="primary"
                  class="custom-primary"
                  matStepperNext
                >
                  Próximo
                </button>
              </div>
            </mat-step>
            <mat-step label="Passo 2" #step2>
              <ng-container *ngTemplateOutlet="stepTwo"></ng-container>
              <div class="actions">
                <button
                  mat-raised-button
                  color="primary"
                  class="custom-primary"
                  matStepperPrevious
                >
                  Voltar
                </button>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </div>
        <div class="divider"></div>
        <div class="sidebar">
          <ng-container *ngTemplateOutlet="sidebar"></ng-container>
        </div>
      </div>
    </ng-template>
  </mat-dialog-content>

  <!-- <div class="historic">
    <ng-container
      class="empty-content"
      *ngIf="!user.payment_link; else noPayment"
    >
      <span class="mat-body-2">Aqui aparecerá seu histórico de pagamento</span>
    </ng-container>
    <ng-template #noPayment>
      <span class="mat-body-2">Cobranças Realizadas:</span><br />
      <a
        *ngIf="user.payment_link"
        mat-stroked-button
        color="primary"
        [href]="user.payment_link"
        target="_blank"
        >Imprimir segunda via</a
      >
    </ng-template>
  </div> -->
</div>
